import { useCallback, useContext } from 'react'
import { useContentStack as useContentStackLib } from '@jarvis/olex-content-management'
import { ConfigContext } from '../store/ConfigContext'
import buildContentStackQuery from '../utils/buildContentStackQuery'

const useContentStack = (
  content_type,
  parsing_function = (data) => data,
  query_type = null,
  additional_params = {}
) => {
  const { printerFamily, getPrinterFamilyTaxonomy } = useContext(ConfigContext)
  const taxonomyCategory = getPrinterFamilyTaxonomy(printerFamily)

  const query_modifier = useCallback(
    (query, newQuery) =>
      query_type
        ? buildContentStackQuery(
            taxonomyCategory,
            query_type,
            additional_params
          )({ query, newQuery })
        : query,
    [query_type, content_type, additional_params, taxonomyCategory]
  )

  const { pageData } = useContentStackLib({
    content_type,
    parsing_function,
    query_modifier
  })

  return {
    pageData: pageData?.data,
    pageError: pageData?.error,
    status: pageData.status
  }
}

export default useContentStack
